import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../core/services/language.service';
import { LoginalertService } from '../core/services/loginalert.service';
import { LanguageEnum } from '../core/models/enums/language-enum';
import { Language } from '../core/models/language';
import { WindowRef } from '../core/services/window.service';
import { LoginalertModel } from '../core/models/loginalert.model';

@Component({
    selector: 'db-app-alert-widget-root',
    templateUrl: './loginalert.component.html',
    styleUrls: ['./loginalert.component.scss']
})
export class LoginalertComponent implements OnInit {

    public loginAlertData: LoginalertModel;
    private languageGlobalService: any;
    public expandView = false;
    public alertTextFromJSON: string;
    public truncatedText: string;
    public plainText: string;
    public textToDisplay: string;
    public stringLengthWithoutHTML: number;
    public allowedLength = 325;
    public OLB_TXT_0292_MoreInfo: string;
    public OLB_TXT_0312_LessInfo: string;


    constructor(private loginalert: LoginalertService, public windowRef: WindowRef) {
    }

    ngOnInit() {
        this.loginalert.getJSON().subscribe(data => {
            this.loginAlertData = data;
            this.listenForLanguageChange();
            this.setDefaultLanguage();
        });
    }

    public setTextToDisplay() {
        this.plainText = this.alertTextFromJSON.replace(/<[^>]*>/g, '');
        this.stringLengthWithoutHTML = this.plainText.toString().length;
        if (this.plainText.length > this.allowedLength) {
            this.truncatedText = this.truncateWithHTML(this.alertTextFromJSON, this.allowedLength);
            this.textToDisplay = this.truncatedText;
        } else {
            this.textToDisplay = this.alertTextFromJSON;
        }
    }

    public toggleText() {
        this.expandView = !this.expandView;
        this.textToDisplay = (this.expandView) ? this.alertTextFromJSON : this.truncatedText;
    }

    public listenForLanguageChange(): void {
        this.languageGlobalService = this.windowRef.nativeWindow.globalServices.AnonymousLanguageService;
        this.languageGlobalService.onLanguageChange((locale: string) => {
            const lang = this.getLanguageFromLocale(locale);
            if (lang.code === 'nl') {
                this.alertTextFromJSON = this.loginAlertData.alertText_NL;
                this.OLB_TXT_0292_MoreInfo = 'Meer info';
                this.OLB_TXT_0312_LessInfo = 'Minder info';
            } else {
                this.alertTextFromJSON = this.loginAlertData.alertText_FR;
                this.OLB_TXT_0292_MoreInfo = 'Voir plus';
                this.OLB_TXT_0312_LessInfo = 'Voir moins';
            }
            this.setTextToDisplay();
            LanguageService.language$.next(lang);
        });
    }

    private setDefaultLanguage(): void {
        if (this.languageGlobalService.language) {
            const l = this.getLanguageFromLocale(this.languageGlobalService.language);
            LanguageService.language$.next(l);
        } else {
            this.languageGlobalService.detectLanguage();
        }
    }

    public getLanguageFromLocale(locale: string): Language {
        return locale && locale === LanguageEnum.FR.locale ? LanguageEnum.FR : LanguageEnum.NL;
    }

    public truncateWithHTML (string, length)  {
        const noHTML = string.replace(/<[^>]*>/g, '');
        // if the string does not need to be truncated
        if (noHTML.length <= length){
            return string;
        }
        // if the string does not contains tags
        if (noHTML.length === string.length){
            return `${string.substring(0, length).trim()}`;
        }

        const substrings =  string.split(/(<[^>]*>)/g).filter(Boolean);
        let count = 0;
        const truncated = [];
        let endIndex = 0;
        for (let i = 0; i < substrings.length; i++) {
            const substr = substrings[i];
            // if the substring isn't an HTML tag
            if (! substr.startsWith('<')){
                if (count > length){
                    continue;
                } else if (substr.length > (length - count - 1 )){
                    const str = substr;
                    const breakChar = length - count - 1;
                    // required as truncation should not be done from middle of word
                    if (str.charAt(breakChar) !== ' '  ){
                        for ( let k = breakChar; k <= substr.length; k++ ){
                            if (( str.charAt(k) === ' ') || (k === substr.length)){
                                truncated.push(substr.substring(0, (k)));
                                break;
                            }
                        }
                    }else{
                        truncated.push(substr.substring(0, (breakChar) - 1) + '');
                    }
                    endIndex = i;
                } else {
                    truncated.push(substr);
                }
                count += substr.length;
            } else {
                if ( (endIndex === 0) || (((endIndex + 1) === i) && (substr.startsWith('</')) ) ) {
                    truncated.push(substr);
                }
            }
        }
        return `${truncated.join('')}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/loginalert/loginalert.component.ts